import { IAreaPart } from '../../types/reducers/offer';

export const getMultiListingSlotsCount = (areaParts: IAreaPart[] | null | undefined): number | null => {
  if (!areaParts || areaParts.length === 0) {
    return null;
  }

  return areaParts.length;
};
